import { render, staticRenderFns } from "./InsightQuicklink.vue?vue&type=template&id=f474e89a&"
import script from "./InsightQuicklink.vue?vue&type=script&lang=js&"
export * from "./InsightQuicklink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports